import { Link, useHistory } from 'react-router-dom';
import { Dropdown, Layout, Menu, Popover } from 'antd';
import { HelpCircle, List, User, Info, Settings, UserX } from 'react-feather';

import { useDisclosure, useWindowSize } from '@/hooks';

import AppHeaderButton from '@/components/_common/AppHeaderButton';

import PageTitle from './PageTitle';
import UserDropdownMenu from './UserDropdownMenu';
import NotificationsDropdownMenu from './NotificationsDropdownMenu';

import logo from '@/assets/images/Logo_Footer.png';
import logoMin from '@/assets/images/Logo-UC-mobile.png';

import './style.less';
import AppBarUserDrawerMenu from './AppBarUserDrawerMenu';
import { useIntl } from 'react-intl';
import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import CustomLink from '@/components/_common/CustomLink';
import { useMainContext } from '@/contexts/MainContextProvider';
import HelpDropdownMenu from './HelpDropdownMenu';
import { Group } from '@/components/_common';
import { APP_NAME, isAppPortocar } from '@/index';

function AppBar() {
  const intl = useIntl().formatMessage;
  const history = useHistory();
  const { width } = useWindowSize();

  const { modalWithoutMoviments } = useMainContext();

  const [showUser, setShowUser] = useDisclosure();

  const menu = (
    <Menu
      items={[
        {
          label: 'Clientes sem movimentação',
          key: 'withoutMovimentsOpened',
          icon: <UserX />,
          onClick: modalWithoutMoviments.toggle,
        },
        {
          label: intl({ id: 'layout.menu.informative' }),
          key: 'informative',
          icon: <Info />,
          onClick: () => history.push('/app/informative'),
        },
        {
          label: intl({ id: 'commons.entity.help' }),
          icon: <HelpCircle />,
          key: 'help',
          className: 'menu-help',
          children: [
            {
              key: 'help-center',
              label: 'Central de Ajuda',
              onClick: () =>
                window.open('https://ajuda.ultracar.com.br/pt', '_blank'),
            },
            {
              key: 'ultracarSupport',
              label: `Suporte ${APP_NAME}`,
              onClick: () =>
                window.open(process.env.REACT_APP_SUPPORT_URL, '_blank'),
            },
          ],
        },
        {
          label: intl({ id: 'commons.entity.settings' }),
          key: 'settings',
          icon: <Settings />,
          onClick: () => history.push('/app/settings/emailSettings'),
        },
        {
          label: intl({ id: 'commons.entity.user' }),
          key: 'user',
          icon: <User />,
          onClick: setShowUser.open,
        },
      ]}
    />
  );

  return (
    <Layout.Header className="app-header">
      <div className="app-header-content">
        {width < 992 ? (
          <div className="logoMin">
            <img
              className="image"
              src={
                isAppPortocar
                  ? '/images/Logo_PortoCar_branca-icon.svg'
                  : logoMin
              }
              alt="logo"
              style={{ width: '60px' }}
            />
          </div>
        ) : (
          <div className="logo">
            <img
              className="image"
              src={isAppPortocar ? '/images/Logo_PortoCar_branca.svg' : logo}
              alt="logo"
            />
          </div>
        )}

        <PageTitle />

        {width < 992 ? (
          <>
            <Group gap={16} style={{ height: '100%' }}>
              <NotificationsDropdownMenu />

              <Dropdown overlay={menu} trigger={['click']}>
                <Group
                  className="icons"
                  style={{ margin: 'auto 0', height: '100%' }}
                >
                  <List color="white" />
                </Group>
              </Dropdown>
            </Group>

            <AppBarUserDrawerMenu
              openUser={showUser}
              closeUser={setShowUser.close}
            />
          </>
        ) : (
          <div className="icons">
            <Popover content="Clientes sem movimentação">
              <AppHeaderButton
                icon={<UserX />}
                onClick={modalWithoutMoviments.toggle}
              />
            </Popover>

            <Link to="/app/informative">
              <Popover content={intl({ id: 'layout.menu.informative' })}>
                <AppHeaderButton icon={<Info />} />
              </Popover>
            </Link>

            <HelpDropdownMenu />

            <NotificationsDropdownMenu />

            <CustomLink
              to="/app/settings/emailSettings"
              disabled={
                !hasPermissions([
                  Authorities.CONFIGURATION_USER_EDIT_SYSTEM_SETTINGS,
                  Authorities.CONFIGURATION_USER_SYSTEM_SETTINGS,
                ])
              }
            >
              <Popover
                content={intl({ id: 'layout.appBar.userDropdown.settings' })}
              >
                <AppHeaderButton
                  icon={
                    <Settings
                      className={
                        !hasPermissions([
                          Authorities.CONFIGURATION_USER_EDIT_SYSTEM_SETTINGS,
                          Authorities.CONFIGURATION_USER_SYSTEM_SETTINGS,
                        ])
                          ? 'icon-disabled'
                          : ''
                      }
                    />
                  }
                />
              </Popover>
            </CustomLink>

            <UserDropdownMenu />
          </div>
        )}
      </div>
    </Layout.Header>
  );
}

export default AppBar;
